import React from 'react';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import ApiClient from '../../helpers/ApiClient';
import config from '../../config';
import Toolbar from '../../components/Toolbar';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, ImageUpload, FileUpload, Select, Checkbox} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ChangeBar from '../../components/ChangeBar';
import IconCheckbox from '../../components/Form/IconCheckbox';
import TableForm from '../../components/TableForm';
import ButtonToolbar from '../../components/ButtonToolbar';
import NavBar from '../../components/NavBar';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'trainer.fetch',
			save: 'trainer.save',
			remove: 'trainer.delete',
		};

		this.changeEvent = 'trainer.change';
		this.savePushState = '/trainer';

		this.messages = {
			remove: 'Opravdu si přejete školitele odstranit?',
			notfound: 'Školitel nenalezen!'
		};

		this.schema = {

			name: {
				class: TextInput,
				label: 'Jméno',
				rules: {
					presence: {message: 'Jméno je povinná položka!'}
				}
			},
			surname: {
				class: TextInput,
				label: 'Příjmení',
			},
			active: {
				class: IconCheckbox,
				label: 'Aktivní',
				value: true
			},
			notice: {
				class: TextArea,
				label: 'Poznámka',
				style: { height: '50px'}
			}
		};
		this.form = new FormManager(this.schema);

	}

	componentDidMount() {
		this.form.on('change', (key, value, values) => {
			if (key == 'name' || key == 'surname') {
				this.title = (values.get('name') ? values.get('name') : '') + ' ' +
					(values.get('surname') ? values.get('surname') : '');
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.name + ' ' + data.surname});
	}

	onSave() {
		this.context.flashMessage({message: 'Školitel byl uložen.'});
	}


	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				visible: !isNew,
				disabled: !canDelete,
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];


		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<NavBar buttons={toolbar} onClose={this.props.closeTab} title="Školitel" />
					<Toolbar title="Školitel">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<ChangeBar visible={this.state.showChangedBar} items={this.state.extChangedItems} onAcceptChanges={() => this.acceptChanges()} onClose={() => this.setState({showChangedBar: false})} />
					<div className="row">
						<div className="col-md-6">
							<TableForm>
								<FormRow name="name" labelWidth={150}/>
								<FormRow name="surname" />
								<FormRow name="active" />
								<FormRow name="notice" />
								<FormRow className="buttons vp-desktop">
									{saveCloseButton}
								</FormRow>
							</TableForm>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Trainer/Form.js